import { Brand, createBranded } from '@deltasierra/type-utilities';

export type ReportingReportableAssetCollectionId = Brand<number, 'ReportingReportableAssetCollectionId'>;
export const ReportingReportableAssetCollectionId = createBranded<ReportingReportableAssetCollectionId>();
